// extracted by mini-css-extract-plugin
export default {"content":"EntityDrawer-module__content__XO7EC","header":"EntityDrawer-module__header__PMCrx"};